"use client";
import React, { useEffect } from "react";
import { useField } from "formik";
import { MaskField } from "react-mask-field";

const Input = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);
  // useEffect(() => {
  //   if (field.value) helpers.setTouched(true);
  // }, [field.value]);
  return (
    <>
      {props.mask ? (
        <MaskField
          className={
            "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " +
            (!meta.error && field.value
              ? "border-green-500 focus:!border-green-500"
              : "") +
            (meta.error && field.value
              ? " border-red-500 focus:!border-red-500"
              : " ")
          }
          {...field}
          {...props}
          id={props.id || props.name}
        />
      ) : (
        <input
          className={
            "border-gray-300 block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border  appearance-none   focus:outline-none focus:ring-0 focus:border-brand-color-secondary peer " +
            (!meta.error && meta.touched
              ? "border-green-500 focus:border-green-500"
              : "") +
            (meta.error && meta.touched
              ? " border-red-500 focus:border-red-500"
              : " ")
          }
          {...field}
          {...props}
          id={props.id || props.name}
        />
      )}

      <label
        htmlFor={props.name}
        className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-brand-color-secondary  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-brand-color-secondary  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
      >
        {label}
      </label>
    </>
  );
};

export default Input;
